import React from 'react';
import { WhatsApp } from '@mui/icons-material';
import { Typography, Stack, Link, Box } from '@mui/material';

const SideMenuHelp = () => {
    return (
        <Stack
            spacing={3}
            sx={{
                width: 1,
                textAlign: 'center',
            }}
        >
            <Box>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Need help? <br />
                    Please contact our helpdesk
                </Typography>
            </Box>
            <Box>
                <Link
                    underline="none"
                    component="a"
                    href="https://wa.me/6285121370236"
                    color="text.primary"
                    variant="subtitle2"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <WhatsApp fontSize="large" color="action" />
                </Link>
            </Box>
        </Stack>
    );
};

export default SideMenuHelp;
